export default function getTotpSession(state) {
  if (state.loginForm && state.loginForm.totpSession) {
    return state.loginForm.totpSession;
  }
  return null;
}